<template>
    <div>
        <button
            type="button"
            class="btn btn-md is-primary"
            @click="$modal.show('upload-file-archive-file')"
        >
            Ladda upp fil
        </button>
        <adaptive-form-modal
            name="upload-file-archive-file"
            primary-button-text="Ladda upp"
            primary-button-class="is-primary"
            title="Ladda upp fil"
            :redirect-to="route('admin.file-archive.folders.show', [modelType, modelId, folderKey])"
            :action="route('api.file-archive.files.store', [modelType, modelId, folderKey])"
        >
            <input
                id="file"
                type="file"
                name="file"
                class="hidden"
                @change="setFile"
            >
            <label class="btn btn-md is-primary cursor-pointer" for="file">
                Välj fil
            </label>

            <span class="ml-md text-sm">
                <span v-if="file">
                    Fil har valts
                </span>
                <span v-else>
                    Ingen fil har valts
                </span>
            </span>

            <div class="text-xs mt-md">
                <span>
                    Största tillåtna filstorleken är {{ maxFileSize }}
                </span>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            modelType: {
                type: String,
                required: true,
            },
            modelId: {
                type: Number,
                required: true,
            },
            folderKey: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                file: null,
            };
        },

        computed: {
            maxFileSize() {
                return (window.App && window.App.maxFileSizeMedia) ? window.App.maxFileSizeMedia : '-';
            },
        },

        methods: {
            setFile(event) {
                this.file = event.target.value;
            },
        },
    };
</script>
